import React from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import "./Disclaimer.css";

/**
 * Переиспользуемый компонент дисклеймера
 * 
 * @param {Object} props
 * @param {string} props.text - Текст дисклеймера
 * @param {boolean} [props.showIcon=true] - Показывать ли иконку восклицательного знака
 * @param {string} [props.type="info"] - Тип дисклеймера: "info", "warning", "error"
 * @param {string} [props.className] - Дополнительные CSS классы
 * @param {Object} [props.style] - Дополнительные inline стили
 */
export const Disclaimer = ({ 
    text, 
    showIcon = true, 
    type = "info", 
    className = "", 
    style = {} 
}) => {
    return (
        <div 
            className={`disclaimer disclaimer_${type} ${className}`}
            style={style}
        >
            {showIcon && (
                <div className="disclaimer__icon">
                    <AiOutlineExclamationCircle />
                </div>
            )}
            <p className="disclaimer__text">{text}</p>
        </div>
    );
};
